export default class StickerUpdateRequest {
  listId;
  itemId;
  stickerId;
  beforeFileName;
  afterFileName;

  constructor(data) {
    this.listId = data.listId;
    this.itemId = data.itemId;
    this.stickerId = data.stickerId;
    this.beforeFileName = data.beforeFileName;
    this.afterFileName = data.afterFileName;
  }
}
